(function() {
  try {
    const currentPath = window.location.pathname;
    const targetPath = '/products/rapid-force-level-iii-duty-holster-shell-only';

    // Normalize path to ignore trailing slashes for comparison
    const normalizedPath = currentPath.replace(/\/$/, '');
    const normalizedTarget = targetPath.replace(/\/$/, '');

    // If we are already on the target page, do not redirect
    if (normalizedPath === normalizedTarget) {
      return;
    }

    // Only apply redirect rules to product pages
    if (/^\/products\//i.test(currentPath)) {
      // Only include shell-only pages (containing 'shell', or the '-dealer' handles, which are Level III replacement shells)
      if (!/shell|-dealer$/i.test(normalizedPath)) {
        return;
      }

      // Check if it is a Level III page (containing 'level-iii', 'level-3', or 'lvl-3')
      if (/level-iii|level-3|lvl-3/i.test(currentPath)) {
        window.location.replace(targetPath);
      }
    }
  } catch (e) {
    console.error('Level III Shell redirects error:', e);
  }
})();
